import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
// import { browserHistory } from 'react-router';
import App from './container/App';
// import registerServiceWorker from './registerServiceWorker';
// import './index.css';
// import './App.css';
import './assets/css/theme-style.css';
import './assets/css/theme-shop.css';
// import 'bootstrap/dist/css/bootstrap-theme.css';
// import { unregister } from './registerServiceWorker';
// unregister();

var ReactGA = require('react-ga');
ReactGA.initialize('UA-102609168-1');

function logPageView() {
    console.log("logPageView : " + window.location.pathname)
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

ReactDOM.render(
    <BrowserRouter onUpdate={logPageView}>
        <App />
    </BrowserRouter>,
    document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js